import create from '../creator'

const initialState = () => ({
  transactionError: '',
  originalUrl: null,
})
const _state = initialState()

const actions = {
  async setError({ commit }, error) {
    commit('setError', error)
  },
  async setOriginalUrl({ commit }, url) {
    commit('setOriginalUrl', url)
  },
}

const mutations = {
  setError(state, error) {
    state.transactionError = error
  },
  setOriginalUrl(state, url) {
    state.originalUrl = url
  },
}

export default create(
  {
    namespaced: true,
    state: _state,
    actions,
    mutations,
  },
  initialState()
)
